import {  useContext } from "react";
import HighchartsReact from "highcharts-react-official";
import CountUp from "react-countup";
import { Fragment, useState, useEffect, useMemo } from "react";
import Loader from "react-js-loader";
import {UserDatailContext} from "../../../../Context/userContext.js";
import { colors4 } from "../../../../utils/constants";
import { LocalStorageService, LocalStorageKeys } from "../../../../utils/LocalStorageService";

const HospitalTestType = (props) => {
  const {Fullscreen,Highcharts,hospitalCityData,hospitalCityTotal,hospitalNameData,
    testTypeTotalCount,testTypePie,testTypeGraphData
  } = props
  const [selectedCityList, setSelectedCityList] = useState(null);
  const [selectedCityObj, setSelectedCityObj] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const userDetails = LocalStorageService.get(LocalStorageKeys.USER_DETAILS);
  
  useEffect(() => {
    if (hospitalCityData && hospitalCityData.length > 0 && hospitalNameData) {
      setSelectedCityList(hospitalNameData[hospitalCityData[0].label]);
      setSelectedCityObj(hospitalCityData[0]);
    }
     /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, [hospitalCityData]);

  const hospitalCities = useMemo(() => ({
    chart: {
      type: 'pie', 
        align: "center",
        verticalAlign: "middle",
        height: 500,
    },
    exporting: {
      enabled: true,
      buttons: {
        contextButton: {
          enabled: false
        }
      }
    },
    accessibility: {
      enabled: false,
      point: {
        valueSuffix: '%'
      }
    },
    title: {
      text: ''
    },
    credits: {
      enabled: false
    },
    tooltip: {
      backgroundColor: 'none',
      borderRadius: 0,
      //padding: 8,
      shadow: false,
      useHTML: true,
      borderWidth: 0,
      // formatter: function () {
      //   return '<div style="background-color:' + this.point.color + '">' + this.point.name + ': ' + this.y + '<br/>' + Math.round(this.point.percentage) + '%</div>';
      // },
      formatter: function () {
        return '<div style="background-color:' + this.point.color + '">' + 
               this.point.name + ': ' + this.y + '<br/>' + 
               this.point.percentage.toFixed(2) + '%</div>';
      },   
      style: {
        color: "white",
        borderWidth: 0,
      }
    },
    legend: {
      symbolWidth: 16,
      symbolRadius: 4,
      //  rectangleSymbol:true
      squareSymbol: false,
      enabled: false
    },
    plotOptions: {
      series: {
        allowPointSelect: true,
        cursor: 'pointer',
        borderRadius: 4,
        size: '90%',
        point: {
          events: {
            click: function() {
              setIsLoading(true);
              const cityData = hospitalCityData.find(city => city.label === this.name);
              setSelectedCityList(hospitalNameData[cityData.label]);
              setSelectedCityObj(cityData);
              setTimeout(() => setIsLoading(false), 500); // Add small delay for smooth transition
            }
          }
        },
        dataLabels: [{
          enabled: true,
          distance: 19,
          format: '{point.name}'
        }, {
          enabled: true,
          distance: -25,
          formatter: function () {
            return this.point.percentage > 2.5 ? `${Math.round(this.point.percentage)}%` : null;
          },
          style: {
            fontSize: '0.7em',
            textOutline: 'none',
          }
        }],
        showInLegend: true,
        colors: hospitalCityData?.map((entry, index) =>
          colors4[index % colors4.length]
        ),
      }
    },
    series: [{
      // name: 'Registrations',
      colorByPoint: true,
      innerSize: '50%',
      data: hospitalCityData?.map(obj => ({ name: obj.label, y: obj.value })),

    }]
  }), [hospitalCityData, hospitalNameData]);
  
 const barChartOptions = useMemo(() => ({
  chart: {
    type: 'column',
    height: 600,
    animation: true,
    spacingTop: 20, 
    events: {
      load: function () {
        const chart = this;
        const xAxisLabels = chart.xAxis[0].labelGroup.element.children;

        // Loop through each x-axis label and add hover behavior
        Array.from(xAxisLabels).forEach((labelEl, index) => {
          labelEl.style.cursor = 'pointer';

          labelEl.addEventListener('mouseenter', () => {
            // Apply hover styles to the label
            labelEl.style.transition = 'all 0.2s ease';
            labelEl.style.fontSize = '13px';
            labelEl.style.fill = '#1E4E69';
            labelEl.style.fontWeight = 'bold';

            // Highlight the corresponding bar
            const point = chart.series[0].points[index];
            if (point && point.graphic) {
              point.graphic.attr({
                fill: '#1E4E69'
              });
              point.graphic.element.style.transform = 'scaleY(1.05)';
              point.graphic.element.style.transition = 'transform 0.2s ease';
            }
          });

          labelEl.addEventListener('mouseleave', () => {
            // Reset label style
            labelEl.style.fontSize = '11px';
            labelEl.style.fill = '#000000';
            labelEl.style.fontWeight = 'normal';

            // Reset bar style
            const point = chart.series[0].points[index];
            if (point && point.graphic) {
              point.graphic.attr({
                fill: colors4[0]
              });
              point.graphic.element.style.transform = 'scaleY(1)';
            }
          });
        });
      }
    }
  },
  accessibility: {
    enabled: false
  },
  title: {
    text: selectedCityObj ? `Hospital Details for ${selectedCityObj.label} (Total: ${selectedCityObj.value})` : '',
    style: {
      fontSize: '16px',
      fontWeight: 'bold'
    }
  },
  subtitle: {
    text: selectedCityList ? `Number of Hospitals: ${selectedCityList.length}` : '',
    style: {
      fontSize: '14px'
    }
  },
  xAxis: {
    categories: selectedCityList ? selectedCityList.map(hospital => hospital.name) : [],
    labels: {
      rotation: -45,
      style: {
        fontSize: '11px',
        color: '#000000'
      }
    }
  },
  yAxis: {
    title: {
      text: 'Number of Cases',
      style: {
        fontSize: '12px'
      }
    },
    labels: {
      style: {
        fontSize: '12px'
      },
      formatter: function () {
        return this.value.toLocaleString();
      }
    }
  },
  tooltip: {
    pointFormat: `City: ${selectedCityObj?.label}<br>Hospital Cases: <b>{point.y}</b>`
  },
  legend: {
    enabled: false
  },
  series: [{
    name: 'Hospitals',
    data: selectedCityList
      ? selectedCityList.map((hospital, index) => ({
          name: hospital.name,
          y: hospital.count,
          color: colors4[0],
          index: index
        }))
      : [],
    borderRadius: 4,
    animation: {
      duration: 500
    }
  }],
  plotOptions: {
    column: {
      dataLabels: {
        enabled: true,
        rotation: 0,
        align: 'center',
        y: -10,
        formatter: function () {
          return this.y.toLocaleString();
        },
        style: {
          fontSize: '11px',
          color: '#000000',
          textOutline: '1px contrast'
        }
      },
      groupPadding: 0.1,
      pointPadding: 0.05
    },
    series: {
      point: {
        events: {
          mouseOver: function () {
            const chart = this.series.chart;
            const labelEl = chart.xAxis[0].labelGroup.element.children[this.index];
            if (labelEl) {
              labelEl.style.transition = 'all 0.2s ease';
              labelEl.style.fontSize = '13px';
              labelEl.style.fill = '#1E4E69';
              labelEl.style.fontWeight = 'bold';
            }
          },
          mouseOut: function () {
            const chart = this.series.chart;
            const labelEl = chart.xAxis[0].labelGroup.element.children[this.index];
            if (labelEl) {
              labelEl.style.fontSize = '11px';
              labelEl.style.fill = '#000000';
              labelEl.style.fontWeight = 'normal';
            }
          }
        }
      }
    }
  },
  credits: {
    enabled: false
  }
 }), [selectedCityList, selectedCityObj]);


  return (
    <Fragment>
      <div className="row mt_80 equal-height-row">  
          {process.env.REACT_APP_TEST_TYPES === "true" && <div className="col-lg-6 col-md-6 col-sm-12 equal-height-col">
          <div className="morph_somatic_card card h-100">
            <div className="card_heading">
              <h6>Test Types</h6>
            </div>
            <div className="card_chart_body">
              <div className="card_chart_heading">
                 <CountUp className="card_chart_countup" duration={5} start={0} end={testTypeTotalCount} />             

                <span
                  className="expand"
                  data-toggle="modal"
                  data-target="#testTypeData"
                >
                  <img alt="" src={Fullscreen} />
                </span>
              </div>
              <div className="modal fade" id="testTypeData">
                <div className="modal-dialog modal-dialog-centered">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h4 className="modal-title">Test Types</h4>
                      <button
                        type="button"
                        className="close"
                        data-dismiss="modal"
                      >
                        <i className="zmdi zmdi-close"></i>
                      </button>
                    </div>
                    <div className="modal-body">
                     {testTypeGraphData ? (
                            <HighchartsReact
                              highcharts={Highcharts}
                              options={testTypePie}
                            />
                          ) : (
                            <Loader
                              type="spinner-circle"
                              bgColor="black"
                              color="#FFFFFF"
                              size={100}
                            />
                          )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="card_chart_box">
                   {testTypeGraphData ? (
                    <HighchartsReact
                      highcharts={Highcharts}
                      options={testTypePie}
                    />
                  ) : (
                    <Loader
                      type="spinner-circle"
                      bgColor="black"
                      color="#FFFFFF"
                      size={100}
                    />
                  )}
              </div>
            </div>
          </div>
        </div>}

        <div className={process.env.REACT_APP_TEST_TYPES === 'true' ?  "col-lg-6 col-md-6 col-sm-12":"col-lg-12 col-md-12 col-sm-12"}>
           <div className="morph_somatic_card card h-100">
            <div className="card_heading">
              <h6>Top 20 Cities</h6>
            </div>
            <div className="card_chart_body">
              <div className="card_chart_heading">
                 <CountUp
                    className="card_chart_countup"
                    duration={5}
                    start={0}
                    end={hospitalCityTotal}
                  />
             

                <span
                  className="expand"
                  data-toggle="modal"
                  data-target="#hospitalCities"
                >
                  <img alt="" src={Fullscreen} />
                </span>
              </div>
              <div className="modal fade" id="hospitalCities">
                <div className="modal-dialog modal-dialog-centered">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h4 className="modal-title">Top 20 Cities</h4>
                      <button
                        type="button"
                        className="close"
                        data-dismiss="modal"
                      >
                        <i className="zmdi zmdi-close"></i>
                      </button>
                    </div>
                    <div className="modal-body">
                    {hospitalCityData ? (
                            <HighchartsReact
                              highcharts={Highcharts}
                              options={hospitalCities}
                            />
                          ) : (
                            <Loader
                              type="spinner-circle"
                              bgColor="black"
                              title={"spinner-circle"}
                              color={"#FFFFFF"}
                              size={100}
                            />
                          )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="card_chart_box">
                 {hospitalCityData ? (
                    <HighchartsReact
                      highcharts={Highcharts}
                      options={hospitalCities}
                    />
                  ) : (
                    <Loader
                      type="spinner-circle"
                      bgColor="black"
                      title={"spinner-circle"}
                      color={"#FFFFFF"}
                      size={100}
                    />
                  )}
                  <p className="chart-disclaimer">
                    Click on a city in the chart to view the associated hospitals in the chart below.
                  </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    

      <div className="row mt_80">
        <div className="col-lg-12 col-md-12 col-sm-12">
          <div className="card graph_card">
            <div className="heading varient_bg">
              <h6 className="mb-0">Hospital Details</h6>
            </div>
            <div className="somatic_graph hospital_graph">
              <div className="panel">
                <div className="panel_body ">
                  {isLoading ? (
                    <Loader
                      type="spinner-circle"
                      bgColor="black"
                      title={"spinner-circle"}
                      color={"#FFFFFF"}
                      size={100}
                    />
                  ) : hospitalNameData ? (
                    <HighchartsReact
                      highcharts={Highcharts}
                      options={barChartOptions}
                    />
                  ) : (
                    <Loader
                      type="spinner-circle"
                      bgColor="black"
                      title={"spinner-circle"}
                      color={"#FFFFFF"}
                      size={100}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </Fragment>
  );
};

export default HospitalTestType;
